import { useEffect } from "react";

/**
 * SEO — sets document.title + updates <meta> tags per route.
 * Also injects JSON-LD product schema when `product` is provided.
 */
export default function SEO({ title, description, canonical, image, product }) {
  useEffect(() => {
    const fullTitle = title ? `${title} — Aperture Enterprises` : "Aperture Enterprises — Opening doors to new possibilities";
    document.title = fullTitle;

    const setMeta = (attr, key, value) => {
      if (!value) return;
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", value);
    };
    const setLink = (rel, href) => {
      if (!href) return;
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
      }
      el.setAttribute("href", href);
    };

    setMeta("name", "description", description);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", canonical);
    setMeta("property", "og:image", image);
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", image);
    setLink("canonical", canonical);

    // Product JSON-LD
    let jsonLdEl = document.getElementById("product-jsonld");
    if (product) {
      const jsonLd = {
        "@context": "https://schema.org",
        "@type": "Product",
        name: product.title,
        description: product.description,
        image: product.image,
        brand: { "@type": "Brand", name: "Aperture Enterprises" },
        category: product.category,
        offers: {
          "@type": "Offer",
          priceCurrency: "USD",
          price: product.price,
          availability: "https://schema.org/InStock",
          url: canonical,
        },
      };
      if (!jsonLdEl) {
        jsonLdEl = document.createElement("script");
        jsonLdEl.type = "application/ld+json";
        jsonLdEl.id = "product-jsonld";
        document.head.appendChild(jsonLdEl);
      }
      jsonLdEl.textContent = JSON.stringify(jsonLd);
    } else if (jsonLdEl) {
      jsonLdEl.remove();
    }
  }, [title, description, canonical, image, product]);

  return null;
}
